import { commonRequest, download, downloadBlob, downloadFile, upload } from '@/common/http/request';
export class BaseController {
    static async get(url, params, options, axiosOption) {
        return await commonRequest(url, params, 'get', options, axiosOption);
    }
    static async post(url, params, options, axiosOption) {
        return await commonRequest(url, params, 'post', options, axiosOption);
    }
    static download(url, params, filename, method, options) {
        return download(url, params, filename, method, options);
    }
    static downloadBlob(url, params, method = 'post', options) {
        return downloadBlob(url, params, method, options);
    }
    /** 下载文件并返回后端下发的文件名（同域部署下可读取 Content-Disposition） */
    static downloadFile(url, params, method = 'post', options) {
        return downloadFile(url, params, method, options);
    }
    static upload(url, params, options) {
        return upload(url, params, options);
    }
}
